// @ts-check

/**
 * Constantes relacionadas aos turnos de trabalho para agrupamento de eventos de prescrição.
 * Centralizadas para fácil manutenção e configuração futura.
 */

/**
 * Hora de início do primeiro turno (formato 24h).
 * Exemplo: 7 = 07:00
 * @type {number}
 */
export const SHIFT_START_HOUR = 7;

/**
 * Minutos de início do primeiro turno (derivado de SHIFT_START_HOUR).
 * @type {number}
 */
export const SHIFT_START_MINUTES = SHIFT_START_HOUR * 60;
